import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ContactUs: React.FC = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [consent, setConsent] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_key: import.meta.env.VITE_WEB3FORMS_ACCESS_KEY,
          subject: "New Contact Form Submission",
          sender_name: formData.fullName,
          sender_email: formData.email,
          message: formData.message,
          phone: formData.phone,
          reply_to: formData.email,
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert("Message sent successfully!");
        setFormData({ fullName: "", email: "", phone: "", message: "" });
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      alert("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-w-screen bg-white text-[#111827]">
      <Navbar />
      <div className="max-w-7xl mx-auto flex flex-col gap-12 pt-40 pb-16 px-4">
        <h2
          className="text-4xl font-['Inter'] font-[500] mb-8 text-center"
          style={{ color: "#111827" }}
        >
          Contact Us
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Contact Info */}
          <div className="space-y-6">
            <p className="text-lg font-['Inter'] font-[400]" style={{ color: "#5A5A60" }}>
              We are always ready to help you and answer your questions. Your
              satisfaction is our priority, and we strive to offer prompt and
              reliable support at all times.
            </p>
            <div className="space-y-4">
              <div>
                <h3 className="font-['Inter'] font-[600]" style={{ color: "#032799" }}>
                  Call Center
                </h3>
                <p>{import.meta.env.VITE_COMPANY_PHONE}</p>
              </div>
              <div>
                <h3 className="font-['Inter'] font-[600]" style={{ color: "#032799" }}>
                  Email
                </h3>
                <p>{import.meta.env.VITE_COMPANY_EMAIL}</p>
              </div>
              <div>
                <h3 className="font-['Inter'] font-[600]" style={{ color: "#032799" }}>
                  Location
                </h3>
                <p>{import.meta.env.VITE_COMPANY_ADDRESS}</p>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden" style={{ boxShadow: "0 4px 24px 0 rgba(249, 76, 9, 0.12)" }}>
              <iframe
                title={`${import.meta.env.VITE_COMPANY_NAME} Location`}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.353838924586!2d77.57314477603674!3d12.949195415367102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15edd7ac5253%3A0xdf88a2bbd2382cb1!2s5%2C%20National%20High%20School%20Road%2C%20Vishweshwarapura%2C%20Basavanagudi%2C%20Bengaluru%2C%20Karnataka%20560004!5e0!3m2!1sen!2sin!4v1758011918313!5m2!1sen!2sin"
                width="100%"
                height="250"
                className="border-0"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <form
            onSubmit={handleSubmit}
            className="p-8 rounded-2xl space-y-4"
            style={{
              border: "1px solid #E6E6E7",
              background: "#fff",
              boxShadow: "0 4px 24px 0 rgba(249, 76, 9, 0.12)",
            }}
          >
            <h3
              className="text-2xl font-['Inter'] font-[600] mb-4 text-center"
              style={{ color: "#032799" }}
            >
              Get in Touch
            </h3>

            <input
              type="text"
              name="fullName"
              placeholder="Full Name *"
              value={formData.fullName}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#032799]"
              style={{ border: "1px solid #E6E6E7", color: "#111827" }}
            />
            <input
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#032799]"
              style={{ border: "1px solid #E6E6E7", color: "#111827" }}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number *"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#032799]"
              style={{ border: "1px solid #E6E6E7", color: "#111827" }}
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              className="w-full p-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#032799]"
              style={{ border: "1px solid #E6E6E7", color: "#111827" }}
            ></textarea>

            <label className="flex items-start gap-2 text-sm font-['Inter'] font-[400]" style={{ color: "#5A5A60" }}>
              <input
                type="checkbox"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
                className="mt-1"
                style={{ accentColor: "#032799" }}
              />
              I consent to receive updates via WhatsApp, email, or SMS.
            </label>

            <button
              type="submit"
              disabled={loading}
              className="w-full transition-transform hover:scale-105 text-white py-3 rounded-md font-['Inter'] font-[500] mt-2 disabled:opacity-50 cursor-pointer"
              style={{
                borderRadius: "12px",
                background: "linear-gradient(0deg, #032799 0%, #032799 100%), #283AAA",
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
              }}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
